import { ReactNode } from "react";
import asSpace from "./asSpace";

export default function asHorizontallyCentered(component: ReactNode) {
  return asSpace(component, {
    display: "flex",
    justifyContent: "center",
  });
}
